export const staticData = {
  en: {
    'bring-your-own-smartphone-byop': 'BYOP',
    '5g': '5G',
    'getting-started': 'Gettting Started',
    'general-questions': 'General Questions',
    'unlimited-plans': 'Unlimited Plans',
    'idnotify': 'IDnotify',
    'phone-devices': 'Phone/Devices',
    'my-account-app': 'My Account App',
    'phone-upgrades': 'Phone Upgrades',
    'mobile-protect': 'Mobile Protect',
    'troubleshooting': 'Troubleshooting',
    'general-information': 'General Information',
    '611611-services': '611611 Services',
    'features': 'Features',
    'policies-and-procedures': 'Policies & Procedures',
    'products': 'Products',
    'international-long-distance': 'International Long Distance',
    'transfer-number': 'Transfer Number',
    'services': 'Services',
    'device-trade-in': 'Device Trade-In',
    'interactive-tutorials': 'Interactive Tutorials'
  }
}
export const customerNames = {
  stacademy: 'Straight Talk',
  tracfone: 'Tracfone',
  simplemobile: 'Simple Mobile',
  net10wireless: 'Net10 Wireless',
  totalwireless: 'Total Wireless',
  wfm: 'Walmart Family Mobile',
  safelink: 'SafeLink',
  pageplus: 'Page Plus',
  gosmart: 'GoSmart'
}



// WEBPACK FOOTER //
// ./src/constants/static-data.js